module.exports = __webpack_public_path__ + "static/hawaii-0-ab25dd1083423eb84e1996a4e24b3bdc.png";